import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ErrorComponent } from 'app/main/pages/miscellaneous/error/error.component';
import { NotAuthorizedComponent } from './not-authorized/not-authorized.component';

// routing
const routes: Routes = [
  {
    path: 'miscellaneous/error',
    component: ErrorComponent,
    data: { animation: 'misc' }
  },
  {
    path: 'miscellaneous/not-authorized',
    component: NotAuthorizedComponent,
    data: { animation: 'notauthorized' }
  }
];

@NgModule({
  declarations: [ErrorComponent],
  imports: [RouterModule.forChild(routes)]
})
export class MiscellaneousModule {}
